export enum ActionTypes {
    SET_SUBSCRIPTION_DATA = "setSubscriptionData",
    SET_SUBSCRIPTION_DATA_CLEAR = "setSubscriptionDataClear",
    SET_SUBSCRIPTION_PLANS_LIST = "setSubscriptionPlansList",
    SET_SUBSCRIPTION_UPDATE = "setSubscriptionUpdate"
}